import i18n from 'i18next';
import { isApiError } from '@/api/fetchWrapper';

/**
 * The message to show under the ZIP field when the backend rejects it, or
 * null when the failure was not a rejection of the value.
 *
 * Only a 400 means "this ZIP is wrong". Every other failure — 404, 5xx,
 * offline, timeout — says nothing about what the candidate typed, so it must
 * not be reported as if they had made a mistake.
 */
export const rejectedZipMessage = (error: unknown): string | null => {
  if (!isApiError(error) || error.status !== 400) return null;

  const body = error.body;
  if (body && typeof body === 'object' && 'zip_code' in body) {
    const detail = (body as { zip_code: unknown }).zip_code;
    const first = Array.isArray(detail) ? detail[0] : detail;
    if (typeof first === 'string' && first.length > 0) return first;
  }

  // A 400 whose body we can't read is still a rejection of this value.
  return i18n.t('residency.zip_invalid');
};
